<div class="adtabcontent">
<app-column-header [headerData]="headerData"></app-column-header>
<div class="admcontent rowlist">
    <ul class="admitemlist fourcolum">
  <li *ngFor="let data of dashboardListData">
      <span (click)="viewPage(data)">
          <svg>
              <use [attr.xlink:href]="srcPath.menuIconPath+'profile'"></use>
          </svg>
      </span>
      <a (click)="viewPage(data)" class="cursrponts">
          {{data.gstibo_menu_name}}
      </a>
      <div class="actions">
          <button class="edit" (click)="editPage(data)">
              <svg>
                  <use [attr.xlink:href]="adminMenuIcon+'newedit'"></use>
              </svg>
          </button>
          <button class="delete" (click)="deletePage(data.gstibo_dashboard_id)">
              <svg>
                  <use [attr.xlink:href]="adminMenuIcon+'trash'"></use>
              </svg>
          </button>
         
      </div>
    <!-- <figure (click)="viewPage(data)" class="back-blue">
      <svg class="icon">
        <use [attr.xlink:href]="srcPath.menuIconPath+'profile'"></use>
      </svg>
    </figure>
    <figcaption (click)="viewPage(data)">
      {{data.gstibo_menu_name}}</figcaption> -->
    <!-- <div class="editApp-pages">
      <a (click)="editPage(data)">Edit</a>
      <a (click)="deletePage(data.gstibo_dashboard_id)">Delete</a>
    </div> -->
  </li>
  </ul>
</div>
</div>
<!-- <div class="iconBlock">
    <div class="appNames" *ngFor="let data of dashboardListData">
        <h4 (click)="viewPage(data)">{{data.gstibo_menu_name}}</h4>
        <p>
            <a (click)="editPage(data)">Edit</a>
            |
            <a (click)="deletePage(data.gstibo_dashboard_id)">Delete</a>
        </p>
    </div>
</div> -->